import React from 'react';
import styled from "styled-components";
import Fab from '@mui/material/Fab';
import { TableViewIcon } from "../../../static/icons";
import { VerifiedUserOutlined } from '@mui/icons-material';

const ProjectsSection = styled.div`
  margin: 0 -2.5rem;

  .section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 2.5rem;
    margin-bottom: 1rem;
  }

  h3 {
    font-family: Roboto;
    font-weight: normal;
    font-size: 18px;
    line-height: 21px;
    color: #E5E5E5;
  }
`;

const ViewAllBtn = styled.button`
  display: flex;
  align-items: center;
  color: #E5E5E5;

  svg {
    margin: 0 14px 0 0;
  }

  &:focus {
    outline: none;
  }

  small {
    font-family: Roboto;
    font-weight: normal;
    margin-top: 2.5px;
  }
`;

const RecentProjectsList = styled.div`
  .project-item {
    font-size: 16px;    
    line-height: 1px;
    height: 65px;
    width: 100%;
    padding-left: 2.5rem;
    display: flex;
    align-items: center;

    &:hover {
      background: rgba(35, 35, 35, 0.8);
    }

    .location {
      font-family: 'Roboto';
      font-size: 16px;
      line-height: 19px;
      font-weight: 400;
      color: #E5E5E5;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 240px;
    }

    .date {
      font-family: 'Open Sans';
      font-size: 11px;
      line-height: 15px;
      color: #A0A0A0;
    }
  }
`;

const iconStyle = {
  width: '48px',
  height: '48px',
  minWidth: '48px',
  minHeight: '48px',
  background: 'rgba(72, 123, 242, 0.25)',
  marginRight: '18px',
  ariaHidden: 'true',
  boxShadow: 'none',
  borderRadius: 30,
  outline: 'none'
};

const locationBackground = {
  pointerEvents: 'none',
  opacity: '1',
  color: '#487BF2',
  height: '24px',
  width: '24px',
  borderRadius: '0px',
  position: 'absolute',
  right: '16.67 %',
  bottom: '8.33 %',
  ariaHidden: 'true'
};

const recentProjects = [
  { id: 1, location: '2043 Burton Ave, East St. Paul, Testing description', status: 'Updated', date: 'March 21, 2021' },
  { id: 2, location: '123 Main Street, Winnipeg, MB Testing description', status: 'Created', date: ' March 22, 2021' }
]

const Projects = (props) => {

  if (props.projectsData == 500) {
    // alert('Error while loading Data');
    return (
      <></>
    )
  } else {
    if (props.projectsData.length == 0) {
      return (
        <ProjectsSection>
          <div className="section-header">
            <h3>Recent Projects</h3>
            <ViewAllBtn>
              <TableViewIcon /> <small>View All</small>
            </ViewAllBtn>
          </div>
        </ProjectsSection>
      )
    } else {
      return (
        <ProjectsSection>
          <div className="section-header">
            <h3>Recent Projects</h3>
            <ViewAllBtn>
              <TableViewIcon /> <small>View All</small>
            </ViewAllBtn>
          </div>
          <RecentProjectsList>
            {props.projectsData.map((project, index) => (
              <div key={index} className="project-item">
                <Fab style={iconStyle}>
                  <VerifiedUserOutlined style={locationBackground} />
                </Fab>
                <div>
                  <p className="location">{project.fields.ADDRESS},{project.fields.REGION}</p>
                  <p className="date">{project.fields.CENTROID} {project.fields.CREATEDDATE}</p>
                </div>
              </div>
            ))}
          </RecentProjectsList>
        </ProjectsSection>
      )
    }
  }

}

export default Projects;